const setCurrency = async (currency) => {
  console.log(`Set currency to ${ currency }`);
  const nowTime = new Date().getTime();
  window.localStorage.setItem('currencied', nowTime);

  // For some reason, this doesn't always work before document ready.
  // const switchResult = await fetch(`/cart/update.js?currency=${ currency }`);
  // location.reload();

  const url = new URL(location.href);
  url.searchParams.set('currency', currency);
  location.assign(url.search);
};

const flagAsCurrencied = () => {
  const nowTime = new Date().getTime();
  window.localStorage.setItem('currencied', nowTime);
};

module.exports = {
  setCurrency,
  flagAsCurrencied,
};

window.currencyUtils = module.exports;